import { render, staticRenderFns } from "./WrongQuestions.vue?vue&type=template&id=4f3e2c70&scoped=true&"
import script from "./WrongQuestions.vue?vue&type=script&lang=js&"
export * from "./WrongQuestions.vue?vue&type=script&lang=js&"
import style0 from "./WrongQuestions.vue?vue&type=style&index=0&id=4f3e2c70&prod&lang=scss&scoped=true&"
import style1 from "./WrongQuestions.vue?vue&type=style&index=1&id=4f3e2c70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3e2c70",
  null
  
)

export default component.exports